/** Per-user flag: org-row follow-up tour dismissed (localStorage). */

export const ORG_TOUR_DISMISSED_PREFIX = "wowzer.orgGuidedTour.dismissed";

export const getOrgTourDismissKey = (userKey) => {
  const id = String(userKey || "").trim();
  if (!id) {
    return ORG_TOUR_DISMISSED_PREFIX;
  }
  return `${ORG_TOUR_DISMISSED_PREFIX}.${id}`;
};

export const isOrgTourDismissed = (userKey) => {
  if (typeof window === "undefined" || !window.localStorage) return false;
  try {
    return window.localStorage.getItem(getOrgTourDismissKey(userKey)) === "1";
  } catch (_) {
    return false;
  }
};

export const setOrgTourDismissed = (userKey) => {
  if (typeof window === "undefined" || !window.localStorage) return;
  try {
    window.localStorage.setItem(getOrgTourDismissKey(userKey), "1");
  } catch (_) {
    /* no-op */
  }
};
